import {Dispatch, FC, SetStateAction, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {useForm} from 'react-hook-form'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
}

type FormValues = {
  imagen: FileList
  comentario: string
}

export const ModalAddObservation: FC<Props> = ({show, setShow}) => {
  const handleClose = () => {
    reset()
    setPreview(null)
    setShow(false)
  }

  const {register, handleSubmit, reset} = useForm<FormValues>()
  const [preview, setPreview] = useState<string | null>(null)

  const onSubmit = async (data: FormValues) => {
    const formData = new FormData()
    formData.append('imagen', data.imagen[0])
    formData.append('comentario', data.comentario)

    console.log('FORM DATA:', data)

    // 👉 aquí tu API
    // await axios.post('/api/cleaning', formData)

    handleClose()
  }

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (file) {
      setPreview(URL.createObjectURL(file))
    }
  }

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-xl'
      size='xl'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        {/* HEADER */}
        <div className='modal-header'>
          <h5 className='modal-title'>Servicios de Limpieza</h5>
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>

        {/* BODY */}
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className='modal-body'>
            {/* INPUT FOTO */}
            <div className='mb-5'>
              <label className='form-label'>Foto</label>
              <input
                type='file'
                accept='image/*'
                capture='environment'
                className='form-control'
                {...register('imagen', {required: true})}
                onChange={handleImageChange}
              />
            </div>

            {/* PREVIEW */}
            {preview && (
              <div className='mb-5'>
                <img
                  src={preview}
                  alt='preview'
                  className='img-fluid rounded'
                  style={{maxHeight: 300}}
                />
              </div>
            )}

            {/* COMENTARIO */}
            <div className='mb-5'>
              <label className='form-label'>Comentario</label>
              <textarea
                className='form-control'
                rows={3}
                placeholder='Escribe un comentario...'
                {...register('comentario', {required: true})}
              />
            </div>
          </div>

          {/* FOOTER */}
          <div className='modal-footer'>
            <button type='button' className='btn btn-light' onClick={handleClose}>
              Cancelar
            </button>
            <button type='submit' className='btn btn-primary'>
              Guardar
            </button>
          </div>
        </form>
      </div>
    </Modal>
  )
}
